import React, { Fragment } from 'react'
import classNames from 'classnames'
import confirmClasses from './Confirm.module.scss'

const Confirm = ({
    heading = null,
    info = null,
    smallPrint = null,
    buttons = [],
    centerButton = true,
    inline = true,
    defaultDimensions = true,
    forceStacked = false,
    reportListView = false,
    newLineAboveButtons = true,
    fixedWidth = true,
    fullHeight = false,
    style,
    largerGap = false
}) => {
    if (buttons.length === 0) {
        return null
    }
    const buttonWrapperClasses = [
        confirmClasses.confirmButtonWrapper,
        {
            [confirmClasses.confirmButtonWrapperHeightFull]: fullHeight,
            [confirmClasses.confirmButtonWrapperHeight]: defaultDimensions,
            [confirmClasses.confirmButtonWrapperHeightReport]: reportListView,
            'grid-wrapper-100': !defaultDimensions,
            'align-center': centerButton,
            'grid-wrapper': buttons.length > 1
        }
    ]
    const buttonBaseClasses = [confirmClasses.confirmButton]
    return (
        <>
            {
                (heading || info || smallPrint) &&
                <>
                    <div className="align-center">
                        {heading && <div className="spacer-small">{heading}</div>}
                        {info && <div className="spacer-small">{info}</div>}
                        {smallPrint && <div className="spacer-small small-print">{smallPrint}</div>}
                    </div>
                    {newLineAboveButtons && <br />}
                </>
            }
            <div className={classNames(buttonWrapperClasses)} style={style}>
                {
                    buttons.map(({
                        buttonClasses,
                        buttonStyle,
                        disabled,
                        handleFn,
                        insertComponent,
                        label,
                        takeEnter
                    }, i) => {
                        if (insertComponent) {
                            return (
                                <Fragment key={i}>
                                    {insertComponent}
                                </Fragment>
                            )
                        }

                        const button = (
                            <button
                                key={i}
                                type={takeEnter || buttons.length === 1 ? 'submit' : 'button'}
                                className={classNames(
                                    buttonBaseClasses,
                                    buttonClasses,
                                    {
                                        [confirmClasses.fixed]: fixedWidth,
                                        'disabled': disabled ?? false
                                    }
                                )}
                                style={buttonStyle}
                                disabled={disabled}
                                onClick={handleFn}>
                                {label}
                            </button>
                        )
                        return buttons.length > 1 || forceStacked ?
                            <div key={i} className={classNames(
                                `col-${Math.floor(12 / (inline ? buttons.length : 1))}`,
                                {
                                    [confirmClasses.stacked]: !inline && !largerGap,
                                    [confirmClasses.stackedLarge]: largerGap
                                }
                            )}>{button}</div> : button
                    })
                }
            </div>
        </>
    )
}

export default Confirm
